<h2 [class.img-present]="config.imgFileName">{{ config.title }}</h2>

<ng-template #valueDisplay let-index="index">
  @let dataPoint = config.data[index]; @let chart = miniChart(index); @if
  (dataPoint) { @if (chart) {
  <span class="data" [class.has-chart]="chart">
    <div class="mini-chart">
      <canvas
        baseChart
        [type]="chartType"
        [data]="chart.data"
        [options]="chart.options"
        [plugins]="chartPlugins"
      ></canvas>
    </div>
  </span>
  <span class="label">
    {{ config.data[index].label }} :
    <span style="font-weight: 600">{{
      dataPoint.value | prettyNumber : true : dataPoint.unit
    }}</span>
  </span>
  } @else {
  <span class="data">
    <!-- Width definer to avoid resizing during animation -->
    <span style="opacity: 0">
      {{ dataPoint.value | prettyNumber : true : dataPoint.unit }}
    </span>
    <!-- Displayed data -->
    <span
      class="data"
      style="position: absolute; opacity: 1; left: 0; z-index: 10"
      [appCountUp]="dataPoint.value"
      [unit]="dataPoint.unit"
    >
    </span>
  </span>
  <span class="label">{{ config.data[index].label }}</span>
  } }
</ng-template>

@if (config.dataPointCardType == 'single') {
<div class="row">
  <div class="col">
    <ng-container
      *ngTemplateOutlet="valueDisplay; context: { index: 0 }"
    ></ng-container>
  </div>
  @if(config.imgFileName) {
  <div class="img-container">
    <img src="../../../../assets/img/{{ config.imgFileName }}.png" alt="" />
  </div>
  }
</div>
} @else if (config.dataPointCardType == 'double') {
<div class="row double">
  <div class="col">
    <ng-container
      *ngTemplateOutlet="valueDisplay; context: { index: 0 }"
    ></ng-container>
  </div>
  <span class="separator" [class.separator--accent]="config.accent"></span>
  <div class="col">
    <ng-container
      *ngTemplateOutlet="valueDisplay; context: { index: 1 }"
    ></ng-container>
  </div>
  @if(config.imgFileName) {
  <img src="../../../../assets/img/{{ config.imgFileName }}.png" alt="" />
  }
</div>

}
